<div class="align">
  @switch (value) {    
    @case ('User') {
      <i
        class="pi pi-user md-16"
        pTooltip="{{'&doc_owner' | translate}}"
        tooltipPosition="top"
      ></i>
    }
    @case ('Group') {
      <i
        class="pi pi-users md-16"
        pTooltip="{{'Group' | translate}}"
        tooltipPosition="top"
      ></i>
    }
    @case ('Public') {
      <i
        class="pi pi-globe md-16"
        pTooltip="{{'Public' | translate}}"
        tooltipPosition="top"
      ></i>
    }
    @case ('System') {
      <i
        class="pi pi-cog md-16"
        pTooltip="{{'Public' | translate}}"
        tooltipPosition="top"
      ></i>
    }
  }
</div>
